import React from 'react';
import { isWordFile, filePreviewUrl, canPreviewWord } from '../../utils/filePreview';

const PreviewPdfFile = ({ url }) => {
  const previewUrl = filePreviewUrl(url);
  if (isWordFile(url) && !canPreviewWord(previewUrl)) {
    return <div role="status">
      <p>Preview unavailable for this Word document. Upload it again to convert it to PDF.</p>
      <a href={url} download>Download Word document</a>
    </div>;
  }
  return (
    <div style={{ width: '100%' }}>
      <iframe
        data-dd-privacy="hidden"
        title="Document preview"
        src={previewUrl}
        width="100%"
        height="700px"
        style={{ border: 'none' }}
      />
    </div>
  );
};

export default PreviewPdfFile;
